import { render, staticRenderFns } from "./GroupExerciseItem.vue?vue&type=template&id=8adcb792&"
import script from "./GroupExerciseItem.vue?vue&type=script&lang=js&"
export * from "./GroupExerciseItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupExerciseItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports